import * as _ from "lodash";
import ExternalLogger from "../../logger/ExternalLogger";

var MenuService = function ($state, $q, $window, $location, LegacyService, MenuNavigationFactory, accountService) {

    var service = this;
    var menuNavigation = [];
    var activeMenuItem = null;
    var activeSubMenuItem = null;
    var detailTitle = '';
    var accountDetailsLoaded = false;
    var logger = ExternalLogger.getInstance('MenuService');
    var throttledGetGroupMenuQuery = _.throttle(MenuNavigationFactory.getGroupMenu.query, 1000, { 'trailing': false });

    /***** Account detail menu routing logic *****/

    /**
     * Returns the current menu item from a list, based on the URL parameters, or undefined.
     */
    function getCurrentMenuItem(menu) {
        //console.log('getCurrentMenuItem - starting');
        var val = null;
        for (var i = 0; i < menu.length; i++) {
            var item = menu[i];
            //console.log('getCurrentMenuItem-?',item);
            if (currentMenuParam(item)) {
                val = item;
                //console.log('getCurrentMenuItem-1',val);
                break;
            }
        }
        if (val === null) {
            for (var i = 0; i < menu.length; i++) {
                var item = menu[i];
                if (currentSubMenuParam(item)) {
                    //console.log('getCurrentMenuItem (sub)-1',val);
                    val = item;
                    break;
                }
            }
        }
        /*
        var val = _.filter(menu, function(item) {
            return currentMenuParam(item) || currentSubMenuParam(item);
        })[0];
        */
        //console.log('getCurrentMenuItem - returning', val);
        return val;
    }

    service.getCurrentMenuItem = getCurrentMenuItem;

    /**
     * Returns the unique menu title to be used as a URL param
     * by parsing the unique URL, grabbing the first parameter and
     * converting it to kebab case. In the non-legacy case the name will be passed
     * in and converted to kebab case.
     */
    function getUniqueMenuTitle(menuItem) {
        var title = null;
        if (!menuItem.url && typeof menuItem === 'string' || menuItem instanceof String) {
            title = _.kebabCase(menuItem);
        } else {
            var url = menuItem.url + '';
            var start = url.lastIndexOf('/') > -1 ? url.lastIndexOf('/') : 0;
            var end = (url.indexOf('?') > -1 ? url.indexOf('?') : url.length);
            url = url.slice(start, end);
            title = _.kebabCase(url.replace(/\/|\#|\./, ''));
        }
        return title;
    }



    service.getUniqueMenuTitle = getUniqueMenuTitle;

    /**
      * Returns the unique module name of  menu item title to be used as a URL param
      * by parsing the unique URL, grabbing the first parameter and
      * converting it to kebab case. In the non-legacy case the name will be passed
      * in and converted to kebab case.
      */

    function getUniqueModuleTitle(menuItem) {
        if (!menuItem.url && typeof menuItem == 'string' || menuItem instanceof String) {
            return _.kebabCase(menuItem);
        } else {
            var url = menuItem.url;
            var start = 0;
            var end = url.lastIndexOf('/') > -1 ? url.lastIndexOf('/') : 0;
            url = url.slice(start, end);
            var title = _.kebabCase(url.replace(/\/|\#|\./, ''));
            return title;
        }
    }

    service.getUniqueModuleTitle = getUniqueModuleTitle;

    service.nonSubMenuGroups = ['investment-options', 'account-details', 'my-contributions',
        'payroll-calendar', 'prior-contributions', 'beneficiary', 'rate-of-return', 'landing', 'demin-landing'];

    /**
     * Thesese are nextgen routes that are 'nested' w/ tabs, etc..
     * for example, if 'on-demand-statements' is active then "map" that to
     * documents-statements for the purpose of determining the active menu item.
     */
    function getMenuItemAliasMappings(val) {
        var aliasMappings = {
            "on-demand-statements": "documents-statements",
            "loan-request": "guided-loan-request"
        };

        var url = val ? val : '';
        var start = url.lastIndexOf('/') > -1 ? url.lastIndexOf('/') : 0;
        var end = (url.indexOf('?') > -1 ? url.indexOf('?') : url.length);
        url = url.slice(start, end);
        //console.log('MenuService.getMenuItemAliasMappings('+val+') mapping?',url,aliasMappings[url]);

        return aliasMappings[val];
    }
    /**
     * Returns whether the given menu item is the current active one.
     */
    function currentMenuParam(menuItem) {
        //MR: Necessary manual parameter checking for now, since $state does not
        //always have the correct parameters available at the moment.
        var params = $window.location.href.split('/');

        if (params[params.length - 1] === 'request') {
            var previous = params[params.length - 2];
            params.push(`${previous}-${params[params.length - 1]}`);
        }

        //the last element might have url parameters.
        //if so, split that string and add the result to the existing array.
        //e.g.  documents-statements?nodeId=20920&accu=Empower
        //     ["documents-statements","nodeId=20920&accu=Empower"]
        if (params[params.length - 1].indexOf('?') > -1) {
            params = params.concat(params[params.length - 1].split('?'));
        }

        var aliasMapping = getMenuItemAliasMappings(params[params.length - 1]);
        if (aliasMapping) {
            //console.log('MenuService.currentMenuParam - found alias mapping',aliasMapping);
            params.push(aliasMapping);
        }

        var rc = (params.indexOf(getUniqueMenuTitle(menuItem)) > -1 || $state.params.menuItem === getUniqueMenuTitle(menuItem));
        //console.log('MenuService.currentMenuParam',rc, params, getUniqueMenuTitle(menuItem), $state.params.menuItem);
        return rc;
    }

    /**
     * Returns whether the given submenu item is the current active one.
     */
    function currentSubMenuParam(subMenuItem) {
        var params = $window.location.href.split('/');
        var rc = $state.params.subMenuItem === getUniqueMenuTitle(subMenuItem);
        //console.log('MenuService.currentSubMenuParam',rc, params, getUniqueMenuTitle(subMenuItem), $state.params.subMenuItem);
        return rc;
    }

    service.setAccountDetailsLoaded = function (loaded) {
        accountDetailsLoaded = loaded;
    };

    service.getAccountDetailsLoaded = function () {
        return accountDetailsLoaded;
    };

    service.getMenuNavigation = function () {
        return menuNavigation;
    };

    service.getActiveMenuItem = function () {
        return activeMenuItem;
    };

    service.getActiveSubMenuItem = function () {
        return activeSubMenuItem;
    };

    service.getDetailTitle = function () {
        return detailTitle;
    };

    service.retrieveMenuNavDetails = function (groupId, needToChangeActiveMenuItem) {
        logger.debug("In retrieveMenuNavDetails()");
        var deferred = $q.defer();
        if (groupId !== null && !needToChangeActiveMenuItem) {
            logger.debug("groupId = {0}, needToChangeActiveMenuItem={1}. About to call MenuNavigationFactory ", [groupId, needToChangeActiveMenuItem]);
            throttledGetGroupMenuQuery({ "groupId": groupId }, function (data) {
                //console.log('menu', _.get(data, '2.subMenu'));
                var tmpMenuNavigation = [];
                angular.forEach(data, function (item) {
                    if (item.subMenu && item.subMenu.length) {
                        tmpMenuNavigation.push(item);
                    } else {
                        logger.info('Menu Item missing subMenu [' + angular.toJson(item) + ']');
                    }
                });
                menuNavigation = tmpMenuNavigation;

                logger.debug("Got menu data. Set activeMenuItem then resolve.");
                service.setActiveMenuItem().then(deferred.resolve);

            });
        } else {
            logger.debug("No need to call factory again. Set activeMenuItem then resolve.");
            service.setActiveMenuItem().then(deferred.resolve);
        }
        return deferred.promise;
    };

    service.retrieveAccountMenuDetails = function () {
        var deferred = $q.defer();

        MenuNavigationFactory.getAccountMenu.query({}, function (data) {
            deferred.resolve(data);
        })
        return deferred.promise;
    }

    service.setSubMenuItem = function () {
        var method = "setSubMenuItem()";
        //Set detail title to active menu item title
        if ($state.params.subMenuItem) {
            //Default sub menu item (no legacy menu URL) case - change state, to change URL and remove submenu breadcrumb
            var subMenuItem = getCurrentMenuItem(activeMenuItem.subMenu);
            if (activeMenuItem.url.indexOf('/#/') > -1 && activeMenuItem.subMenu.indexOf(subMenuItem) === 0) {
                $state.go('accountDetails.subMenu.iframe', { menuItem: $state.params.menuItem, subMenuItem: $state.params.subMenuItem });
            }
            if (!subMenuItem) {
                return $state.go('accountDetails.error');
            } else {
                activeSubMenuItem = subMenuItem;
                detailTitle = subMenuItem.displayText;
                //logger.debug("{0} - activeSubMenu detailTitle: {1}",[method, detailTitle]);
            }
        } else if (!activeMenuItem.subMenu) {
            activeSubMenuItem = null;
            detailTitle = activeMenuItem.displayText;
            //logger.debug("{0} - activeMenuItem detailTitle: {1}",[method, detailTitle]);
        }
    };

    service.setActiveMenuItem = function () {
        //console.log("setActiveMenuItem - In setActiveMenuItem()");
        var deferred = $q.defer();
        if (menuNavigation && menuNavigation.length > 0) {
            var menuItems = [].concat.apply([], _.map(menuNavigation, function (category) {
                return category.subMenu;
            }));

            //console.log("setActiveMenuItem - calling getCurrentMenuItem() to get activeMenuItem");
            activeMenuItem = getCurrentMenuItem(menuItems);
            //console.log('setActiveMenuItem - activeMenuItem',activeMenuItem);
            if (activeMenuItem) {

                if (!_.isUndefined(activeMenuItem)) {

                    if ($location.url().indexOf("account-details") > 0) {

                        var tmpActiveMenuItem = null;
                        var tmpMenuItem = menuItems[0];
                        if (tmpMenuItem.subMenu && tmpMenuItem.subMenu.length > 0) {
                            tmpActiveMenuItem = tmpMenuItem.subMenu[0];
                        } else {
                            tmpActiveMenuItem = tmpMenuItem;
                        }

                        if (service.getUrlForNavItem(tmpActiveMenuItem).indexOf("account-details") > 0) {
                            //console.log("setActiveMenuItem - resetting activeMenuItem to first item in the menu if the browser URL is account details");
                            activeMenuItem = tmpActiveMenuItem;
                        } else {
                            //console.log("setActiveMenuItem - resetting activeMenuItem to null as account details not found in menu");
                            activeMenuItem = null;
                        }

                        deferred.resolve();
                        $window.dispatchEvent(new CustomEvent('activeMenuItemUpdated'));
                        return deferred.promise;
                    }
                }


                //logger.debug("got activeMenuItem. Set subMenuItem then resolve. {0}",[JSON.stringify(activeMenuItem)]);
                service.setSubMenuItem();
                if (!activeSubMenuItem && activeMenuItem.subMenu && activeMenuItem.subMenu.length > 0) {
                    //Setting submenu item to the first one - default case
                    activeSubMenuItem = activeMenuItem.subMenu[0];
                }

                //determine if the iframe url needs to be set for a legacy 'i-framed' feature.
                var isLegacy = LegacyService.isLegacy(activeMenuItem) || LegacyService.isLegacy(activeSubMenuItem);
                if (isLegacy) {
                    var tmpMenuItem = activeSubMenuItem ? activeSubMenuItem : activeMenuItem;
                    LegacyService.initIframeView(tmpMenuItem, accountService.getActiveGroupAccount());
                }

                deferred.resolve();
                $window.dispatchEvent(new CustomEvent('activeMenuItemUpdated'));
            } else {
                logger.debug("activeMenuItem is undefined. Resolve.");
                deferred.resolve();
                $window.dispatchEvent(new CustomEvent('activeMenuItemUpdated'));
                //return $state.go('accountDetails.error');
            }
        } else {
            //No menu navigation - error
            // Commented out the accountDetails.error state to prevent redirect to error page from Account selections (listing) page
            // when user has selected an account yet
            //-- $state.go('accountDetails.error');
            logger.debug('MenuNavigation array has no data. deferred reject.');
            deferred.reject();
        }
        return deferred.promise;
    };


    service.setActiveSubMenuItem = function (navItem) {
        var deferred = $q.defer();
        if (navItem !== null && activeMenuItem !== null && activeMenuItem.subMenu && activeMenuItem.subMenu.length > 0) {
            var index = activeMenuItem.subMenu.indexOf(navItem);
            if (index > -1)
                activeSubMenuItem = activeMenuItem.subMenu[index];

            deferred.resolve();
        }
        else {
            deferred.reject();
        }
        return deferred.promise;
    };

    service.getUrlForAcctSubMenuItem = function (navItem, groupId) {
        return getUrlForSubMenuItem(navItem, null, groupId);
    };

    service.getUrlForNavItem = function (navItem, subMenuItem) {
        return getUrlForSubMenuItem(navItem, subMenuItem, accountService.getActiveGroupAccount().groupId);
    };

    function getUrlForSubMenuItem(navItem, subMenuItem, groupId) {
        var urlStr = LegacyService.getCurrentDomain() + 'participant/accounts/#/account/' +
            accountService.getActiveGroupAccount().individualId + '/' + groupId;

        //MR: Seems counterintuitive to allow real pages to use legacy
        //routing based on simply whether they contain submenus, but all pages
        //that have submenus have the # in the URL
        //May change this logic in the future depending on if the menu response changes.
        if (navItem.subMenu) {
            var navSubItem = subMenuItem ? subMenuItem : navItem.subMenu[0];
            if (service.nonSubMenuGroups.indexOf(service.getUniqueMenuTitle(navItem)) > -1) {
                urlStr += '/' + service.getUniqueMenuTitle(navItem) + '/' + service.getUniqueMenuTitle(navSubItem);
            } else { //Include submenu

                // In order to allow us to use NextGen views inside the iframes on the account pages, we have created
                // a separate "ngfeat" path (otherwise the "feat" path would process them as an iframe page, which we
                // do not want). To take advantage of this, PWS should include a `type` property with the value "nextGen"
                // for the subMenu item. If the "type" property is not set or is not "nextGen", the subMenu item will be
                // processed as an iframe URL as before.

                //urlStr += navSubItem.type && navSubItem.type === "nextGen" ? '/ngfeat/' : '/feat/';
                if (navSubItem.url && (navSubItem.url.indexOf('/#/') > -1 || navSubItem.type === "nextGen")) {
                    urlStr += '/ngfeat/';
                } else {  // iframes, legacy
                    urlStr += '/feat/';
                }
                urlStr += service.getUniqueMenuTitle(navItem);
                if (navSubItem !== null && navSubItem !== undefined) {
                    urlStr += '/' + service.getUniqueMenuTitle(navSubItem);
                }

            }
        } else if (navItem.url && navItem.url.indexOf('##/') > -1) {//keep subdirectory/module on the url
            urlStr += '/' + service.getUniqueModuleTitle(navItem) + '/' + service.getUniqueMenuTitle(navItem);
        } else if (navItem.url && navItem.url.indexOf('#/') > -1) {
            urlStr += '/' + service.getUniqueMenuTitle(navItem);
        } else if (navItem.type === "nextGen") {
            urlStr += '/ngfeat/' + service.getUniqueMenuTitle(navItem);
        } else {
            urlStr += '/feat/' + service.getUniqueMenuTitle(navItem);
        }
        return urlStr;
    }

    service.getMenuItemByTxnCode = function (txnCode) {
        var method = "MenuService.getMenuItemByTxnCode() ";
        logger.debug("{0}- Enter method. TxnCode= {1}", [method, txnCode]);

        if (menuNavigation && menuNavigation.length > 0) {
            // collect all menu items (level 1 and level 2) into a flat array.
            var menuItemsLevel1 = [].concat.apply([], _.map(menuNavigation, function (category) {
                return category.subMenu;
            }));
            var menuItemsAndChild = [].concat.apply(menuItemsLevel1, _.map(menuItemsLevel1, function (category) {
                return (category.subMenu !== null ? category.subMenu : []);
            }));
            // matching by the transaction code
            var navItem = _.filter(menuItemsAndChild, function (item) {
                return (item.transactionCode && item.transactionCode === txnCode);
            })[0];

            if (navItem) {
                logger.debug("{0}- Found menu item by txnCode. navItem=[id={1},displayText={2},url={3}",
                    [method, navItem.id, navItem.displayText, navItem.url]);
                return navItem;
            }
            else {
                logger.debug("{0}- No match. Return null.", [method]);
                return null;
            }
        }
        else {
            logger.debug("{0}- Menu is not available. Return null.", [method]);
            return null;
        }
    }
};


MenuService.$inject = ['$state', '$q', '$window', '$location', 'LegacyService', 'MenuNavigationFactory', 'accountService'];

export default MenuService;
